import React, { Component } from 'react';
import logo from './Assets/Logo.png';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Dashboard from './Components/Dashboard';
import Login from './Components/Login/Login';
import AppBar from 'material-ui/AppBar';
import DashboardStyles from './Components/DashboardStyles';
import injectTapEventPlugin from 'react-tap-event-plugin';


import './App.css';

injectTapEventPlugin();

class App extends Component {

    constructor(props) {
        super(props);

        const logged = localStorage.getItem('agua_dashboard_logged');
        this.state = {
            logged: logged
        }

        this.enterToDashboard = this.enterToDashboard.bind(this);
    }
    enterToDashboard() {
        localStorage.setItem('agua_dashboard_logged', true);
        this.setState({
            logged: true
        });
    }
    render() {

        return (
            <MuiThemeProvider>
                <div className="App">
                    <AppBar
                      title="Dashboard de indicadores"
                      iconElementLeft={<img src={logo} className="App-logo" alt="logo" />}
                      style={DashboardStyles.appBar}
                      titleStyle={{color: 'rgb(76, 117, 188)'}}
                    />
                    {(() => {
                        if (this.state.logged) {
                            return <Dashboard />
                        } else {
                            return <Login
                                enterToDashboard={this.enterToDashboard}
                            />
                        }
                    })()}

                </div>
            </MuiThemeProvider>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js